import styled from 'styled-components';

// Success Screen Styles
export const SuccessContainer = styled.div`
  text-align: center;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  height: 100%;

  @media screen and (max-width: 768px) {
    padding: 20px 16px calc(16px + env(safe-area-inset-bottom, 0px)) 16px;
    justify-content: space-between;
  }
`;

export const SuccessTitle = styled.h2`
  font-family: Roboto;
  font-size: 1.75rem;
  font-weight: 700;
  color: #171c24;
  text-align: left;
  margin: 0 0 12px 0;

  @media screen and (max-width: 768px) {
    font-size: 1.375rem;
    line-height: 1.3;
    margin-bottom: 12px;
  }
`;

export const SuccessDescription = styled.p`
  font-family: Rubik;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #171c24;
  margin: 0 0 16px 0;
  line-height: 1.4;
  text-align: left;

  @media screen and (max-width: 768px) {
    font-size: 0.875rem;
    line-height: 1.4;
    margin-bottom: 16px;
  }
`;

export const BackToShoppingLink = styled.a`
  display: block;
  font-family: Rubik;
  font-size: 0.9375rem;
  font-weight: 400;
  color: #125d8a;
  text-decoration: underline;
  cursor: pointer;
  margin: 8px 0 0 0;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 0.875rem;
    margin: 0 0 20px 0;
  }
`;

export const SuccessContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 768px) {
    justify-content: space-between;
  }

  #success-content-1 {
    margin-bottom: 16px;

    @media screen and (max-width: 768px) {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      padding-bottom: 16px;
      margin-bottom: 0;
    }
  }
`;

export const RecurringCard = styled.div`
  box-shadow: 0px 4px 4px 0px #00000040;
  background-color: #ffffff;
  border-radius: 20px;
  padding: 20px 16px 16px 16px;
  text-align: left;
  margin-top: 24px;

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.15);
    margin-top: 16px;
  }
`;

export const RecurringIcon = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 12px;

  img {
    max-width: 100px;
    height: auto;
  }

  @media screen and (max-width: 768px) {
    margin-bottom: 8px;

    img {
      max-width: 80px;
    }
  }
`;

export const RecurringTitle = styled.h3`
  font-family: Roboto;
  font-size: 1.25rem;
  font-weight: 700;
  color: #137435;
  margin: 0 0 8px 0;
  line-height: 1.3;

  @media screen and (max-width: 768px) {
    font-size: 1.125rem;
  }
`;

export const RecurringDescription = styled.p`
  font-family: Roboto;
  font-size: 0.875rem;
  font-weight: 400;
  color: #137435;
  margin: 0 0 16px 0;
  line-height: 1.4;

  @media screen and (max-width: 768px) {
    font-size: 0.8125rem;
    margin-bottom: 12px;
  }
`;

export const WhatsAppButton = styled.button`
  width: 100%;
  border-radius: 8px;
  background-color: #00a81f;
  color: #ffffff;
  font-family: Rubik;
  font-size: 1.125rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  text-decoration: none;

  svg {
    width: 24px;
    height: 24px;
  }

  @media screen and (max-width: 768px) {
    padding: 14px 16px;
    font-size: 1rem;
  }
`;
